import { StandardTable } from "@/components/table/StandardTable";
import { AppColors } from "@/styles/colors";
import { Card, Flex } from "@chakra-ui/react";
import { dollarHeaderElements } from "../../schema/header-elements";
import { DollarData, DollarValue } from "../../schema/price-board.schema";
import dayjs from "dayjs";
import { formatCurrency } from "@/utils/format-currency";

interface Props {
  sectionData?: DollarData;
}

export const DollarPriceCard = ({ sectionData }: Props) => {
  return (
    <Card.Root
      maxW="full"
      marginTop="30px"
      borderRadius="8px"
      data-testid="dollar-price-card"
    >
      <Card.Body
        paddingX="10px"
        paddingY="12px"
        borderRadius="8px"
        border={`1px solid ${AppColors.WHITE_BORDER_1}`}
      >
        <Flex flexDir="column" gap="18px">
          <StandardTable
            headers={dollarHeaderElements}
            items={
              sectionData?.dolarDivisa.map((el: DollarValue) => ({
                ...el,
                fecha: dayjs(el?.fecha).format("DD/MM/YYYY"),
                compra: `$${formatCurrency(el?.compra)}`,
                venta: `$${formatCurrency(el?.venta)}`,
              })) ?? []
            }
            selection={[]}
            setSelection={() => null}
            noSelection
            noActions
            noBorder
          />
        </Flex>
      </Card.Body>
    </Card.Root>
  );
};
